<div class="form">
    <form [formGroup]="resetForm" (ngSubmit)="submit()" *ngIf="result==null">
        <div class="title">Reset password</div>
        <app-alert />

        <div class="label">Email</div>
        <input type="text" required formControlName="email" class="field" maxlength="50">

        <div class="label">Password</div>
        <div class="password-input">
            <input [type]="passwordState.type" class="field" required formControlName="password" autofocus>
            <span class="password-toggle" (click)="passwordState.toggle()" [class.password-visible]="passwordState.visible"></span>
        </div>

        <div class="label">Confirm password</div>
        <div class="password-input">
            <input [type]="passwordState.type" class="field" required formControlName="confirmPassword">
            <span class="password-toggle" (click)="passwordState.toggle()" [class.password-visible]="passwordState.visible"></span>
        </div>

        <button type="submit" [disabled]="isLoading" class="button">
            <span [hidden]="isLoading">Reset</span>
            <img src="../../../assets/img/spinner.svg" alt="Loading" [hidden]="!isLoading"/>
        </button>
    </form>

    <div class="reset-result-message" *ngIf="result!=null">
        <span *ngIf="result == 'token_expired'">Password reset link has expired.<br> If you still need to reset the password, please request a new link.</span>
        <span *ngIf="result == 'error'">Server encountered an error.<br>Please try again. If the error persists, please contact support&#64;15club.golf</span>

        <div *ngIf="result == 'success'">
            <span>Password has been reset successfully</span>
            <button routerLink="/login">Log in</button>
        </div>
    </div>
</div>